import styled from 'styled-components';

import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

export const StyledPackagesAvatar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const StyledPackagesAvatarContent = styled.div`
  overflow: hidden;
`;

export const StyledPackagesAvatarUserName = styled(OverflowTooltip).attrs({
  autoTipOnEllipsis: true,
  triggerTarget: OverflowTooltip.TRIGGER_TARGETS.TOOLTIP,
})``;

export const StyledPackagesAvatarCompanyName = styled(OverflowTooltip).attrs({
  autoTipOnEllipsis: true,
  triggerTarget: OverflowTooltip.TRIGGER_TARGETS.TOOLTIP,
  getTargetProps: () => ({
    style: { color: theme.colors.charcoal600, fontSize: 12 },
  }),
})``;
